import {css} from 'lit';
export const styles = css`:host{display:contents}.trigger{display:var(--bl-tooltip-trigger-display,inline-flex);cursor:pointer}bl-popover{--bl-popover-background-color:var(--bl-color-info);--bl-popover-arrow-display:block;--bl-popover-border-size:0px;--bl-popover-max-width:424px}.content{color:var(--bl-color-neutral-full)}`;
export default styles;
